
(function () {
    
    'use strict';
       
    var TransversalElementsCmp = {
        controller: TransversalElementsCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'transversal-elements.component.html'
    };
    
    angular.module('itxApp.header').component('transversalElements', TransversalElementsCmp);
    
    TransversalElementsCmpCtrl.$inject = [
        '$scope',
        'ItxHeaderFct',
        'ngDialog',
        'imAccessService',
        'UserService',
        'ItxGiftCardSvc',
        'NavigationService',
        'CommonServices',
        '$timeout'
    ];

    function TransversalElementsCmpCtrl (
        $scope,
        ItxHeaderFct,
        ngDialog,
        imAccessService,
        UserService,
        ItxGiftCardSvc,
        NavigationService,
        CommonServices,
        $timeout
    ) {

        var _this = this;
        
        _this.loginActive = false;
        _this.ItxHeaderFct = ItxHeaderFct;
        _this.searchWrapperActive = false;
        _this.isHome = NavigationService.isHomePage();
        _this.isWebapp = CommonServices.isWebapp();

        var iUrlJSON = inditex.decodeUrl(location.href);
        if (iUrlJSON.params['from_email']) {
            ItxHeaderFct.signIn();
        }

        inditex.onReady(function() {

            // Modal reload para Black Friday
            UserService.showReloadPageModal('BF_2019');

            // Añade la disponibilidad de las tarjetas si alguna de ellas está activa
            ItxGiftCardSvc.getGiftCardsValues()
            .then(function(cardValues) {
                inditex.iStoreJSON.details.giftCardAvailable = false;
                if(cardValues.physical || cardValues.virtual) {
                    inditex.iStoreJSON.details.giftCardAvailable = true;
                }
            });
            
            //ItxApiSvc.getiCategoryTreeJSON().then(function () {
               
                _this.checkParamsUrl();
                ItxHeaderFct.loadEmpathyX();
                
            //});
        
        });
        
        _this.$onInit = function () {
            ItxHeaderFct.setPageVisited();
        };


        _this.checkIsOpenForSale = () => {
            _this.isOpenForSale = joyr.catalog.utils.isOpenForSale.bind(inditex); // TODO    
            if (!_this.isOpenForSale()) {
                $('body').addClass('is-close-for-sale');
            }
        };
        
        _this.checkParamsUrl = () => {
            if(iUrlJSON.params.openlogin == 'ENABLED'){
                if(!joyr.user.utils.isAuthenticated()){
                    sessionStorage.setItem('FROM_NEWSLETTER',true);
                    if (_this.isMobile) {
                        ngDialog.open({
                            template: 'user-access-dialog-wrapper.tpl',
                            className: 'new-modal ma-modal-md ma-modal-macro ma-login-modal ngdialog-theme-plain ',
                            showClose: true,
                            bindToController: true,
                            preCloseCallback: function () {
                            }
                        });
                        // IMAnalytics Login para pantallas pequenas
                        imAccessService.createView('acceso', 'login');
                    }
                    else{
                        ItxHeaderFct.toggleLogin();
                    }
                }
            }
        };

    }
})();